"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type FC, type PropsWithChildren, use, useState } from "react";
import { useStore } from "zustand";
import { createNotesStore, type NotesState, type NotesStore } from "~/client/services";
interface NotesStoreProviderProps {
  readonly initialState?: NotesState;
}
type NotesStoreApi = ReturnType<typeof createNotesStore>;
export const NotesStoreContext = createContext<NotesStoreApi | undefined>(undefined);
export const NotesStoreProvider: FC<PropsWithChildren<NotesStoreProviderProps>> = t0 => {
  const $ = _c(7);
  const {
    children,
    initialState: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      data: [],
      isPending: false
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const initialState = t2;
  let t3;
  if ($[2] !== initialState) {
    t3 = () => createNotesStore(initialState);
    $[2] = initialState;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [store] = useState(t3);
  let t4;
  if ($[4] !== children || $[5] !== store) {
    t4 = <NotesStoreContext value={store}>{children}</NotesStoreContext>;
    $[4] = children;
    $[5] = store;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const useNotesStore = selector => {
  const store = use(NotesStoreContext);
  if (!store) {
    throw new Error("useNotesStore must be used within a NotesStoreProvider");
  }
  return useStore(store, selector);
};